export const GooglePlayIcon = () => (
  <svg
    width="112"
    height="33"
    viewBox="0 0 112 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M107.564 32.3135H4.13707C1.86271 32.3135 0 30.4948 0 28.2743V4.03914C0 1.81859 1.86271 -5.2927e-05 4.13707 -5.2927e-05H107.564C109.838 -5.2927e-05 111.701 1.81859 111.701 4.03914V28.2743C111.701 30.4948 109.838 32.3135 107.564 32.3135Z"
      fill="black"
    />
    <path
      d="M107.564 0.647227C109.479 0.647227 111.038 2.16899 111.038 4.03914V28.2743C111.038 30.1444 109.479 31.6662 107.564 31.6662H4.13707C2.2216 31.6662 0.662965 30.1444 0.662965 28.2743V4.03914C0.662965 2.16899 2.2216 0.647227 4.13707 0.647227H107.564ZM107.564 -5.2927e-05H4.13707C1.86271 -5.2927e-05 0 1.81859 0 4.03914V28.2743C0 30.4948 1.86271 32.3135 4.13707 32.3135H107.564C109.838 32.3135 111.701 30.4948 111.701 28.2743V4.03914C111.701 1.81859 109.838 -5.2927e-05 107.564 -5.2927e-05Z"
      fill="#A6A6A6"
    />
    <path
      d="M39.2339 8.27514C39.2339 8.94968 39.027 9.48993 38.6195 9.89283C38.151 10.3705 37.5408 10.6108 36.793 10.6108C36.0783 10.6108 35.4681 10.3664 34.9675 9.88475C34.4659 9.39601 34.2156 8.79619 34.2156 8.07823C34.2156 7.36026 34.4659 6.76044 34.9675 6.27574C35.4681 5.79003 36.0783 5.54565 36.793 5.54565C37.1488 5.54565 37.488 5.61735 37.8117 5.75064C38.1344 5.88495 38.3971 6.06671 38.5874 6.29088L38.1551 6.71702C37.8231 6.33431 37.3712 6.14547 36.793 6.14547C36.2717 6.14547 35.8198 6.3232 35.436 6.68168C35.0565 7.04116 34.8662 7.50668 34.8662 8.07823C34.8662 8.64977 35.0565 9.11933 35.436 9.47882C35.8198 9.83325 36.2717 10.015 36.793 10.015C37.3463 10.015 37.8118 9.83325 38.1789 9.47478C38.4209 9.23747 38.5585 8.9103 38.5947 8.49224H36.793V7.90858H39.1966C39.2256 8.03481 39.2339 8.15699 39.2339 8.27514Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M43.0472 6.25151H40.7894V7.7864H42.8248V8.37006H40.7894V9.90496H43.0472V10.4997H40.1502V5.65674H43.0472V6.25151Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M45.7384 10.4997H45.0992V6.25151H43.7143V5.65674H47.1243V6.25151H45.7384V10.4997Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M49.592 10.4997V5.65674H50.2302V10.4997H49.592Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M53.0589 10.4997H52.4249V6.25151H51.0349V5.65674H54.449V6.25151H53.0589V10.4997Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M60.9049 9.87668C60.4157 10.3664 59.8096 10.6108 59.0866 10.6108C58.3595 10.6108 57.7535 10.3664 57.2642 9.87668C56.7761 9.38793 56.533 8.78811 56.533 8.07823C56.533 7.36834 56.7761 6.76852 57.2642 6.27978C57.7535 5.79003 58.3595 5.54565 59.0866 5.54565C59.8054 5.54565 60.4115 5.79003 60.9007 6.28382C61.393 6.7766 61.6361 7.37238 61.6361 8.07823C61.6361 8.78811 61.393 9.38793 60.9049 9.87668ZM57.7369 9.47074C58.1051 9.83326 58.5529 10.015 59.0866 10.015C59.6162 10.015 60.0681 9.83326 60.4322 9.47074C60.7994 9.10822 60.9855 8.6427 60.9855 8.07823C60.9855 7.51375 60.7994 7.04823 60.4322 6.68572C60.0681 6.3232 59.6162 6.14144 59.0866 6.14144C58.5529 6.14144 58.1051 6.3232 57.7369 6.68572C57.3697 7.04823 57.1836 7.51375 57.1836 8.07823C57.1836 8.6427 57.3697 9.10822 57.7369 9.47074Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M62.5328 10.4997V5.65674H63.3085L65.7204 9.42328H65.7483L65.7204 8.49225V5.65674H66.3585V10.4997H65.6925L63.1668 6.54738H63.1389L63.1668 7.48245V10.4997H62.5328Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M56.3758 17.5724C54.4324 17.5724 52.8448 19.0165 52.8448 21.0088C52.8448 22.985 54.4324 24.4441 56.3758 24.4441C58.3233 24.4441 59.9109 22.985 59.9109 21.0088C59.9109 19.0165 58.3233 17.5724 56.3758 17.5724ZM56.3758 23.091C55.3095 23.091 54.3921 22.2317 54.3921 21.0088C54.3921 19.7698 55.3095 18.9256 56.3758 18.9256C57.4421 18.9256 58.3636 19.7698 58.3636 21.0088C58.3636 22.2317 57.4421 23.091 56.3758 23.091ZM48.6715 17.5724C46.724 17.5724 45.1406 19.0165 45.1406 21.0088C45.1406 22.985 46.724 24.4441 48.6715 24.4441C50.618 24.4441 52.2025 22.985 52.2025 21.0088C52.2025 19.0165 50.618 17.5724 48.6715 17.5724ZM48.6715 23.091C47.6042 23.091 46.6837 22.2317 46.6837 21.0088C46.6837 19.7698 47.6042 18.9256 48.6715 18.9256C49.7379 18.9256 50.6553 19.7698 50.6553 21.0088C50.6553 22.2317 49.7379 23.091 48.6715 23.091ZM39.5038 18.6257V20.0858H43.0751C42.9707 20.9018 42.6914 21.5016 42.2632 21.9196C41.742 22.4245 40.9301 22.985 39.5038 22.985C37.306 22.985 35.585 21.2532 35.585 19.1073C35.585 16.9615 37.306 15.2297 39.5038 15.2297C40.6922 15.2297 41.5568 15.6831 42.195 16.2708L43.2489 15.2418C42.3563 14.4098 41.169 13.7706 39.5038 13.7706C36.4899 13.7706 33.957 16.1648 33.957 19.1073C33.957 22.0499 36.4899 24.4441 39.5038 24.4441C41.1328 24.4441 42.3563 23.9231 43.3182 22.9456C44.3038 21.9832 44.611 20.6301 44.611 19.5375C44.611 19.1982 44.582 18.8862 44.5303 18.6257H39.5038ZM76.9918 19.7576C76.7012 18.9892 75.8045 17.5724 73.978 17.5724C72.168 17.5724 70.6611 18.965 70.6611 21.0088C70.6611 22.9335 72.1525 24.4441 74.1517 24.4441C75.7683 24.4441 76.7012 23.4818 77.0849 22.9213L75.8852 22.1408C75.4849 22.7123 74.9398 23.091 74.1517 23.091C73.3688 23.091 72.8072 22.7406 72.4472 22.0499L77.1542 20.1484L76.9918 19.7576ZM72.1928 20.9018C72.1525 19.5769 73.2467 18.8983 74.0307 18.8983C74.6451 18.8983 75.1663 19.1982 75.3401 19.6274L72.1928 20.9018ZM68.3671 24.2351H69.9143V14.1371H68.3671V24.2351ZM65.8331 18.3379H65.7814C65.4339 17.936 64.7709 17.5724 63.9311 17.5724C62.1687 17.5724 60.5573 19.0831 60.5573 21.0199C60.5573 22.9456 62.1687 24.4441 63.9311 24.4441C64.7709 24.4441 65.4339 24.0776 65.7814 23.6635H65.8331V24.1563C65.8331 25.4701 65.1143 26.1759 63.9549 26.1759C63.0096 26.1759 62.4231 25.5095 62.1811 24.949L60.8355 25.4973C61.2234 26.4082 62.2504 27.5291 63.9549 27.5291C65.769 27.5291 67.2997 26.4869 67.2997 23.9513V17.7815H65.8331V18.3379ZM64.0635 23.091C62.9972 23.091 62.1046 22.2195 62.1046 21.0199C62.1046 19.8091 62.9972 18.9256 64.0635 18.9256C65.1143 18.9256 65.9428 19.8091 65.9428 21.0199C65.9428 22.2195 65.1143 23.091 64.0635 23.091ZM84.2358 14.1371H80.5352V24.2351H82.0783V20.409H84.2358C85.9496 20.409 87.6303 19.1982 87.6303 17.2725C87.6303 15.3479 85.9455 14.1371 84.2358 14.1371ZM84.2761 19.0043H82.0783V15.5417H84.2761C85.4283 15.5417 86.0861 16.4758 86.0861 17.2725C86.0861 18.0541 85.4283 19.0043 84.2761 19.0043ZM93.8152 17.5533C92.7002 17.5533 91.5408 18.0339 91.064 19.0993L92.4334 19.6597C92.7282 19.0993 93.2701 18.9175 93.8431 18.9175C94.6436 18.9175 95.4555 19.3871 95.4679 20.2161V20.3221C95.1887 20.1646 94.5909 19.9313 93.8555 19.9313C92.3807 19.9313 90.8779 20.724 90.8779 22.2034C90.8779 23.5565 92.0859 24.428 93.4439 24.428C94.4823 24.428 95.0553 23.9705 95.4152 23.4384H95.4679V24.2189H96.9583V20.3454C96.9583 18.555 95.589 17.5533 93.8152 17.5533ZM93.629 23.087C93.1243 23.087 92.421 22.8426 92.421 22.2317C92.421 21.4501 93.2981 21.1502 94.0572 21.1502C94.7367 21.1502 95.0553 21.2966 95.4679 21.4895C95.3469 22.4245 94.5226 23.087 93.629 23.087ZM102.388 17.7744L100.614 22.1519H100.562L98.7279 17.7744H97.0638L99.8191 23.8918L98.247 27.2958H99.8594L104.105 17.7744H102.388ZM88.4784 24.2351H90.0256V14.1371H88.4784V24.2351Z"
      fill="white"
    />
    <path
      d="M8.63405 6.09006C8.391 6.33847 8.25034 6.72522 8.25034 7.22608V25.0914C8.25034 25.5923 8.391 25.979 8.63405 26.2275L8.69404 26.282L18.9477 16.2749V16.0386L8.69404 6.03149L8.63405 6.09006Z"
      fill="url(#paint0_linear_1_61)"
    />
    <path
      d="M22.3619 19.6123L18.9478 16.2749V16.0386L22.366 12.7012L22.4425 12.7447L26.4907 14.9935C27.6459 15.6317 27.6459 16.6819 26.4907 17.3241L22.4425 19.5689L22.3619 19.6123Z"
      fill="url(#paint1_linear_1_61)"
    />
    <path
      d="M22.4426 19.5688L18.9478 16.1567L8.63406 26.2274C9.01778 26.6213 9.64351 26.6687 10.3551 26.2749L22.4426 19.5688Z"
      fill="url(#paint2_linear_1_61)"
    />
    <path
      d="M22.4426 12.7446L10.3551 6.03857C9.64351 5.64878 9.01778 5.69624 8.63406 6.09006L18.9478 16.1567L22.4426 12.7446Z"
      fill="url(#paint3_linear_1_61)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_61"
        x1="18.0373"
        y1="25.2775"
        x2="4.48376"
        y2="11.3955"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.0066" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_61"
        x1="27.995"
        y1="16.1556"
        x2="7.97419"
        y2="16.1556"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_61"
        x1="20.5422"
        y1="14.3019"
        x2="2.16244"
        y2="-4.52327"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_61"
        x1="6.03789"
        y1="32.1712"
        x2="14.2453"
        y2="23.765"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
)
